import React, { useState, useContext } from 'react';
import axios from 'axios';
import { AuthContext } from '../../contexts/AuthProvider';
import toast from 'react-hot-toast';
import PrimaryButton from '../../Components/Button/PrimaryButton';
import SmallSpinner from '../../Components/Spinner/SmallSpinner';
import { useLocation, useNavigate } from 'react-router-dom';
import { setAuthToken } from '../../api/auth';



const Signup = () => {
  const { createUser, updateUserProfile } = useContext(AuthContext);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [code, setCode] = useState('');
  const [isCodeSent, setIsCodeSent] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(1);  // Step 1 for registration, Step 2 for code verification
  const navigate = useNavigate();
  const location = useLocation()
  const from = location.state?.from?.pathname || '/'
  // Step 1: Send the verification code to the user's email
  const sendVerificationCode = async () => {
    try {
      setLoading(true);
      const response = await axios.post('https://mirai-server.vercel.app/verify-email', { email });
      if (response.data.message) {
        setIsCodeSent(true);
        toast.success(response.data.message);
        setStep(2);  // Move to Step 2: Verification code input
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error('Failed to send verification code.');
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
  
    if (step === 1) {
      // Step 1: Send verification code and proceed to Step 2
      sendVerificationCode();
    } else if (step === 2) {
      // Step 2: Submit the verification code and automatically create the account if verified
      try {
        const response = await axios.post('https://mirai-server.vercel.app/submit-code', { email, code });
        if (response.data.message) {
          setIsVerified(true);
          toast.success('Verification successful!');
          
          // Automatically create the account after successful verification
          const result = await createUser(email, password);
          const user = result.user;
  
          // Set token after successful account creation
          await setAuthToken(user);
  
          // Update user profile
          await updateUserProfile(name);
  
          toast.success('Account created successfully!');
          setLoading(false);
  
          // Navigate to dashboard and refresh the page
          navigate('/dashboard');
          window.location.reload(); // Refresh the page after navigation
        }
      } catch (error) {
        setLoading(false);
        toast.error('Invalid verification code.');
      }
    }
  };
  
  
  
  return (
    <div className="flex justify-center items-center pt-8 h-screen">
      <div className="flex flex-col  p-6 rounded-md sm:p-10 bg-white w-[40%] border border-gray-500 shadow-md">
        <div className="mb-8 text-center">
          <h1 className="my-3 text-4xl font-bold text-gray-900 font-jost">Signup</h1>
          <p className="text-sm text-gray-900 font-jost">Create a new account</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-12">
          {/* Step 1: Name, Email, and Password */}
          {step === 1 && (
            <div className="space-y-4">
              <div>
                <label htmlFor="name" className="block mb-2 text-sm font-jost text-gray-900">Name</label>
                <input
                  type="text"
                  name="name"
                  id="name"
                  placeholder="Enter Your Name Here"
                  className="w-full px-3 py-2 border rounded-md border-gray-500 bg-white"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>
              <div>
                <label htmlFor="email" className="block mb-2 text-sm font-jost text-gray-900">Email address</label>
                <input
                  type="email"
                  name="email"
                  id="email"
                  placeholder="Enter Your Email Here"
                  className="w-full px-3 py-2 border rounded-md border-gray-500 bg-white"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div>
                <label htmlFor="password" className="block mb-2 text-sm font-jost text-gray-900">Password</label>
                <input
                  type="password"
                  name="password"
                  id="password"
                  placeholder="*******"
                  className="w-full px-3 py-2 border rounded-md border-gray-500 bg-white"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              <PrimaryButton
                type="submit"
                classes="w-full px-8 py-3 shadow-lg font-semibold rounded-md bg-blue-900 font-jost hover:bg-blue-900 hover:text-gray-100 duration-150 text-gray-100"
              >
                {loading ? <SmallSpinner /> : 'Send Verification Code'}
              </PrimaryButton>
            </div>
          )}

          {/* Step 2: Verification Code */}
          {step === 2 && isCodeSent && (
            <div className="space-y-4">
              <div>
                <label htmlFor="code" className="block mb-2 text-sm font-jost text-gray-900">Enter Verification Code</label>
                <input
                  type="text"
                  name="code"
                  id="code"
                  placeholder="Enter the code you received"
                  className="w-full px-3 py-2 border rounded-md border-gray-500 bg-white"
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  required
                />
              </div>
              <PrimaryButton
                type="submit"
                classes="w-full px-8 py-3 shadow-lg font-semibold rounded-md bg-blue-900 font-jost hover:bg-blue-900 hover:text-gray-100 duration-150 text-gray-100"
              >
                {loading ? <SmallSpinner /> : 'Verify Code'}
              </PrimaryButton>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default Signup;
